import { Link } from "react-router-dom";
import { Stack } from "@volca/ui/components/ui/stack";
import { profitabilityRunPath } from "@/profitability/routes";
import type { EnrichedProfitabilityPeriod } from "@/profitability/types";

export const PeriodLink = ({ run }: { run: EnrichedProfitabilityPeriod }) => (
  <Stack align="start" gap={1} className="min-w-0">
    <Link
      to={profitabilityRunPath(run.id)}
      onClick={(event) => event.stopPropagation()}
      className="max-w-full rounded-sm font-medium [overflow-wrap:anywhere] hover:underline focus-visible:ring-2 focus-visible:ring-focus focus-visible:outline-none"
    >
      {run.display.period}
    </Link>
    <span className="text-xs text-subtle">{run.display.span}</span>
  </Stack>
);
